import { render, staticRenderFns } from "./ResourceBookingsPage.vue?vue&type=template&id=22c355a0&scoped=true"
import script from "./ResourceBookingsPage.vue?vue&type=script&lang=js"
export * from "./ResourceBookingsPage.vue?vue&type=script&lang=js"
import style0 from "./ResourceBookingsPage.vue?vue&type=style&index=0&id=22c355a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c355a0",
  null
  
)

export default component.exports